export const Production = {
  API_URL: 'https://coresrs.com/api',
  ENVIRONMENT: 'production',
  GA_ID: 'UA-45307701-7',
  MAILCHIMP_URL: 'https://coresrs.us10.list-manage.com/subscribe/post-json?u=352cadb8a3a758c4a2d642bdf&id=39727f8838',
  RECAPTCHA_SITE_KEY: '6Lf4X6QZAAAAALgaN9Btj6Nz8ytNDdgitALXyCb3',
  VERSION: process.env.VERSION
};
